import { formattedMessageSentAt } from "@circle-react/helpers/dateTimeHelpers/formattedMessageSentAt";
import type { Source } from "@circle-react/types/CommunityInbox/Message";
import { TiptapEditor } from "@circle-react-shared/uikit/TipTap";
import { Typography } from "@circle-react-shared/uikit/Typography";
import { Sources } from "./Sources";

interface ContentBlockProps {
  authorName: string;
  body: object;
  isUserMessage: boolean;
  sources?: Source[];
  timestamp: string;
}
export const ContentBlock = ({
  authorName,
  timestamp,
  body,
  sources,
  isUserMessage,
}: ContentBlockProps) => {
  const time = formattedMessageSentAt(timestamp).time;

  return (
    <div className="min-w-0 grow">
      <div className="flex items-center gap-1.5">
        <div className="max-w-[200px] truncate">
          <Typography.LabelSm weight="semibold" color="text-darkest" truncate>
            {authorName}
          </Typography.LabelSm>
        </div>
        <Typography.LabelSm weight="medium" color="text-timestamp">
          {time}
        </Typography.LabelSm>
      </div>
      <div className="text-dark whitespace-pre-line text-sm font-normal">
        <TiptapEditor
          editable={false}
          rich_text_body={body}
          shouldShowPreviewBlocks={isUserMessage}
          shouldSupportCodeBlocks
          shouldSupportTables
        />
      </div>
      {sources && (
        <div className="mt-4">
          <Sources sources={sources} />
        </div>
      )}
    </div>
  );
};
